export default __webpack_public_path__ + "static/social-f67f876413c3951ba0cd94794975ca4b.jpg";